import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Role_instances, _Role_baseUrlThunk;
class Role extends SDKResource {
    constructor(config) {
        super(config);
        _Role_instances.add(this);
    }
    /**
     * Get a list of all Roles. A [Role](https://docs.oystehr.com/oystehr/services/iam/roles/) defines an access policy that can be assigned to any number of [Developers](https://docs.oystehr.com/oystehr/services/iam/developers/), [Users](https://docs.oystehr.com/oystehr/services/app/users/), and [M2M Clients](https://docs.oystehr.com/oystehr/services/iam/m2m-clients/).
     *
     * Access Policy Action: `IAM:ListAllRoles`
     * Access Policy Resource: `IAM:Role`
     */
    list(request) {
        return this.request('/iam/role', 'get', __classPrivateFieldGet(this, _Role_instances, "m", _Role_baseUrlThunk).bind(this))(request);
    }
    /**
     * Create a new Role. A [Role](https://docs.oystehr.com/oystehr/services/iam/roles/) defines an access policy that can be assigned to any number of [Developers](https://docs.oystehr.com/oystehr/services/iam/developers/), [Users](https://docs.oystehr.com/oystehr/services/app/users/), and [M2M Clients](https://docs.oystehr.com/oystehr/services/iam/m2m-clients/).
     *
     * Access Policy Action: `IAM:CreateRole`
     * Access Policy Resource: `IAM:Role`
     */
    create(params, request) {
        return this.request('/iam/role', 'post', __classPrivateFieldGet(this, _Role_instances, "m", _Role_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Get the Role with the provided ID. A [Role](https://docs.oystehr.com/oystehr/services/iam/roles/) defines an access policy that can be assigned to any number of [Developers](https://docs.oystehr.com/oystehr/services/iam/developers/), [Users](https://docs.oystehr.com/oystehr/services/app/users/), and [M2M Clients](https://docs.oystehr.com/oystehr/services/iam/m2m-clients/).
     *
     * Access Policy Action: `IAM:GetRole`
     * Access Policy Resource: `IAM:Role`
     */
    get(params, request) {
        return this.request('/iam/role/{roleId}', 'get', __classPrivateFieldGet(this, _Role_instances, "m", _Role_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Update the Role with the provided ID. A [Role](https://docs.oystehr.com/oystehr/services/iam/roles/) defines an access policy that can be assigned to any number of [Developers](https://docs.oystehr.com/oystehr/services/iam/developers/), [Users](https://docs.oystehr.com/oystehr/services/app/users/), and [M2M Clients](https://docs.oystehr.com/oystehr/services/iam/m2m-clients/).
     *
     * Access Policy Action: `IAM:UpdateRole`
     * Access Policy Resource: `IAM:Role`
     */
    update(params, request) {
        return this.request('/iam/role/{roleId}', 'patch', __classPrivateFieldGet(this, _Role_instances, "m", _Role_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Delete the Role with the provided ID. A [Role](https://docs.oystehr.com/oystehr/services/iam/roles/) defines an access policy that can be assigned to any number of [Developers](https://docs.oystehr.com/oystehr/services/iam/developers/), [Users](https://docs.oystehr.com/oystehr/services/app/users/), and [M2M Clients](https://docs.oystehr.com/oystehr/services/iam/m2m-clients/).
     *
     * Access Policy Action: `IAM:DeleteRole`
     * Access Policy Resource: `IAM:Role`
     * Will fail if any entities hold the Role or if Role is assigned as the default patient role for the project
     */
    delete(params, request) {
        return this.request('/iam/role/{roleId}', 'delete', __classPrivateFieldGet(this, _Role_instances, "m", _Role_baseUrlThunk).bind(this))(params, request);
    }
}
_Role_instances = new WeakSet(), _Role_baseUrlThunk = function _Role_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { Role };
//# sourceMappingURL=role.js.map
